import _ from 'lodash';
import { Fetch, hashifyDictionary } from 'barnyard/utils/';
import * as constants from '../constants';


export const manufacturersFetch = () => dispatch => Fetch({
  url: '/api/products/manufacturers/?history=1',
  success: (json) => {
    dispatch({
      type: constants.MANUFACTURERS_FETCH_SUCCESS,
      entities: _.keyBy(json, 'id')
    });
  }
});

export const manufacturersSearch = searchQuery => (dispatch) => {
  const search = hashifyDictionary(searchQuery);
  return Fetch({
    url: '/api/products/manufacturers/search/',
    body: searchQuery,
    success: (results) => {
      dispatch({
        type: constants.MANUFACTURERS_SEARCH_SUCCESS,
        results,
        query: search,
      });
    }
  });
};
